import { DateTimePicker } from '@mui/x-date-pickers';
import dayjs from 'dayjs';

/**
 * Date + time picker for `date_time` custom-attribute conditions/actions. Unlike `RulesDatePicker`
 * (which also offers relative "rolling" dates), a date_time value is always an absolute instant, so
 * this commits an ISO string and stays fully controlled by the rule value.
 */
export const RulesDateTimePicker = ({
  value,
  timezone,
  onChange,
}: {
  value?: string;
  timezone?: string;
  onChange: (isoValue: string) => void;
}) => {
  return (
    <DateTimePicker
      value={value ? dayjs(value) : null}
      timezone={timezone}
      slotProps={{ textField: { size: 'small', sx: { minWidth: '14rem' } } }}
      onChange={(next) => {
        if (next === null) {
          onChange('');
          return;
        }

        if (next.isValid()) {
          onChange(next.toISOString());
        }
      }}
    />
  );
};
